import axios from "axios";
import {
  GET_YEAR_QUESTIONS_REQUEST,
  GET_YEAR_QUESTIONS_SUCCESS,
  GET_YEAR_QUESTIONS_FAIL,
  GET_AVAILABLE_YEARS_REQUEST,
  GET_AVAILABLE_YEARS_SUCCESS,
  GET_AVAILABLE_YEARS_FAIL,
  CLEAR_ERRORS,
} from "../constants/questionConstants";

// Normalize API base to avoid double slashes when concatenating paths
const __raw_api_path = process.env.REACT_APP_API_BASE_URL || '/api/v1';
const _api_path = __raw_api_path.replace(/\/+$/, '');

//get year all questions
export const getYearQuestions =
  (examId, examType, subjects, year, shuffleQuestions, shuffleOptions, selectedTopics, questionLimit, university = null, subscriptionId = null, userId = null) => async (dispatch) => {
    try {
      dispatch({
        type: GET_YEAR_QUESTIONS_REQUEST,
      });
      // const { data } = await axios.get(
      //   `${_api_path}/get-year-questions/${subjectId}/${year}`
      // );

      // Sanitize subscriptionId before sending; allow backend fallback with userId+examId if missing
      const safeSub = (subscriptionId && subscriptionId !== 'undefined' && subscriptionId !== 'null' && String(subscriptionId).trim() !== '') ? subscriptionId : undefined;
  // Send examType as-is; backend now supports 'both'. Default to objective only if missing
  const normalizedExamType = (!examType) ? 'objective' : examType;
      const { data } = await axios.post(`${_api_path}/get-year-questions`, {
        examId,
        examType: normalizedExamType,
        subjects: subjects,
        year: year,
        shuffleQuestions,
        shuffleOptions,
        selectedTopics,
        questionLimit,
        university,
        subscriptionId: safeSub,
        userId
      });
      // console.log("data", data)
      dispatch({
        type: GET_YEAR_QUESTIONS_SUCCESS,
        payload: data,
        questionCount: data.totalQuestions,
        currentExam: data.exam,
        availableYears: Array.isArray(data.availableYears) ? data.availableYears.map(y => typeof y === 'object' ? Number(y.year) : Number(y)) : data.availableYears
      });
    } catch (error) {
      dispatch({
        type: GET_YEAR_QUESTIONS_FAIL,
        payload: error,
      });
    }
  };

// Fetch available years for selected subjects (and optional university)
export const getAvailableYears = (
  examType,
  subjects,
  university = null,
  subscriptionIdOverride = null,
  userIdOverride = null
) => async (dispatch) => {
  try {
    dispatch({ type: GET_AVAILABLE_YEARS_REQUEST });

    // Backend doesn't have a dedicated endpoint; reuse get-year-questions with minimal limit
    // The controller already computes available years based on subjects; we only need the years list
    // Sanitize subscriptionId from localStorage before sending
    const sanitizeId = (candidate) => {
      if (!candidate && candidate !== 0) {
        return undefined;
      }
      if (typeof candidate === 'object') {
        if (candidate === null) {
          return undefined;
        }
        if (candidate._id) {
          return sanitizeId(candidate._id);
        }
        if (candidate.id) {
          return sanitizeId(candidate.id);
        }
        return undefined;
      }
      const asString = String(candidate).trim();
      if (!asString || asString === 'undefined' || asString === 'null') {
        return undefined;
      }
      return asString;
    };

    const storedSub = localStorage.getItem('userSubscription');
    const safeSub = sanitizeId(subscriptionIdOverride) || sanitizeId(storedSub);
    const storedUser = JSON.parse(localStorage.getItem('userInfo') || '{}')._id;
    const resolvedUserId = sanitizeId(userIdOverride) || sanitizeId(storedUser);

    const { data } = await axios.post(`${_api_path}/get-year-questions`, {
      examId: localStorage.getItem("examId"),
  examType: examType,
      subjects: subjects,
      // Use a sentinel year to indicate "all" and rely on backend to return available years
      year: undefined,
      shuffleQuestions: false,
      shuffleOptions: false,
      selectedTopics: [],
      questionLimit: 1,
      university,
      subscriptionId: safeSub || null,
      userId: resolvedUserId || null
    });

    // Expect backend to include availableYears in response; fallback to [] if missing
    const rawYears = Array.isArray(data?.availableYears) && data.availableYears.length > 0
      ? data.availableYears
      : Array.isArray(data?.years)
        ? data.years
        : [];
    const years = rawYears
      .map((year) => typeof year === 'object' ? Number(year.year) : Number(year))
      .filter((year) => !Number.isNaN(year));
    dispatch({
      type: GET_AVAILABLE_YEARS_SUCCESS,
      payload: years
    });
  } catch (error) {
    dispatch({
      type: GET_AVAILABLE_YEARS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
